export const passwordMinCharacters = password => {
  return password?.length >= 6 || false;
};
export const passwordContainNumber = password => {
  return /\d/.test(password);
};
export const passwordContainUppercase = password => {
  return password && /[A-Z]/.test(password);
};
export const passwordContainLowercase = password => {
  return password && /[a-z]/.test(password);
};
export const isValidPassword = password => {
  return (
    passwordMinCharacters(password) &&
    passwordContainNumber(password) &&
    passwordContainUppercase(password) &&
    passwordContainLowercase(password)
  );
};
